export function pxtorem(px: string | number | undefined) {
  px = px || 0;
  const res = (Number(px) / 50).toFixed(4) + "rem";
  return res;
}

export function rem2px(rem: string | number | undefined) {
  rem = rem || 0;
  const res = (Number(rem) * 50).toFixed(4) + "px";
  return res;
}

export function rem2pxNumber(rem: string | number | undefined) {
  rem = rem || 0;
  const res = Number(rem) * 50;
  return res;
}

export const getRatio = () => {
  try {
    // 获取计算后的样式，而不是内联样式
    const fontSize = window.getComputedStyle(document.documentElement).fontSize;
    // 提取数字部分
    const fontSizeNum = parseFloat(fontSize);

    if (isNaN(fontSizeNum)) {
      console.warn("无法获取有效的 fontSize，使用默认值");
      return 1; // 默认返回 1 作为比例
    }

    return fontSizeNum / 50;
  } catch (error) {
    console.error("获取 ratio 时出错:", error);
    return 1; // 出错时返回默认值
  }
};
